import React from 'react';
import {FormControl, FormGroup} from 'react-bootstrap';
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";

export const ActivityTypeFilter = props => {
    const {Value, UpdateValue, ActivityTypes} = props;

    usePrimeCache([ActivityFeedFilterService])

    const activityFeedFilters = ActivityFeedFilterService.CachedValues()?.result;
    if(!activityFeedFilters) {
        return null;
    }
    
    const updateValue = (x) => {
        if (UpdateValue) {
            UpdateValue(x?.target?.value ?? null);
        }
    }

    const filterFiltersOnEventTypes = (filter) => {
        //get activity type ids that exist in this context.
        let activityTypeIds = ActivityTypes.map((x) => x.activityTypeId);

        //only show filters that work against the activity types we have.
        return filter.ActivityFeedFilterConditions.some((x) => activityTypeIds.includes(x.activityTypeId));
    }

    return <FormGroup controlId="formControlsSelect">
        <FormControl
            as="select"
            placeholder="Activity Type"
            value={Value ? Value.activityFeedFilterId : ""}
            onChange={updateValue}
        >
            <option value={""}>Activity Type</option>
            {
                activityFeedFilters.filter((x) => filterFiltersOnEventTypes(x)).map((x) => {
                    return <option
                        key={x.activityFeedFilterId}
                        value={x.activityFeedFilterId}
                    >
                        {x.name}
                    </option>;
                })
            }
        </FormControl>
    </FormGroup>
};


